import { managerNavigationItems } from 'module/navigation/constants/manager-navigation-items';
import { Route } from 'react-router-dom';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ROUTES } from 'module/navigation/enums/routes.enums';
import { GracenoteProvider } from 'context/gracenoteContext';

const managerContentRoutes = managerNavigationItems.filter(({ contentComponent }) => contentComponent);

const isExact = (path: string) => {
	switch (path) {
		// case ROUTES.USER:
		//     return false;
		default:
			return true;
	}
};

export default function Manager(): JSX.Element {
	return (
		<>
			<DndProvider backend={HTML5Backend}>
				
				{managerContentRoutes.map(({ path, contentComponent: Component }, index) => {
					const Wrapped =
						path === ROUTES.GAMEMASTER
							? () => (
								<GracenoteProvider>
									<Component />
								</GracenoteProvider>
							)
							: Component;

					return (
						<Route
							key={index}
							exact={isExact(path)}
							path={path}
							component={Wrapped}
						/>
					);
				})}
			</DndProvider>
		</>
	);
}
